/* eslint-disable no-unused-vars */
import React from "react";
import { Navbar } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { resizableRoute } from "pages/_components/Resizable";
import * as i18n from "util/i18n";
import { componentPropTypes, defaultPropTypes } from "./customProductHead";
import Back from "./_components/Back";

const CustomProductHead = (props) => {
    const {
        renderMenuOption,
        backLinkTo,
        children,
        onBack,
        className,
        addClassName,
        replace,
        title,
        titleText,
        accessibilityTextId,
        titleId,
        defaultTitle,
    } = props;

    // let buttons = [];

    // if (exportList) {
    //     const { handleClick, isFetchingExport } = props;

    //     buttons = [
    //         ...buttons,
    //         <div className="toolbar-item download" key="exportList">
    //             <Dropdown
    //                 image="images/figma/icon/download.svg"
    //                 label={exportList || "global.download"}
    //                 buttonClass="btn btn-outline"
    //                 fetching={isFetchingExport}
    //                 pullRight>
    //                 <Button
    //                     onClick={() => handleClick("pdf")}
    //                     label="global.download.pdf"
    //                     className="dropdown__item-btn"
    //                     bsStyle="link"
    //                 />
    //                 <Button
    //                     onClick={() => handleClick("xls")}
    //                     label="global.download.xls"
    //                     className="dropdown__item-btn"
    //                     bsStyle="link"
    //                 />
    //             </Dropdown>
    //         </div>,
    //     ];
    // }

    return (
        <>
            <header className={`view-header custom-product-head ${className}`}>
                <Helmet>
                    <title>
                        {// eslint-disable-next-line no-nested-ternary
                        titleId && titleId !== ""
                            ? `Bi-Bank - ${i18n.get(titleId)}`
                            : defaultTitle && defaultTitle !== ""
                            ? defaultTitle
                            : "Bi-Bank"}
                    </title>
                </Helmet>
                <Navbar collapseOnSelect fluid>
                    <Navbar.Header className={`toolbar ${addClassName}`}>
                        {(onBack || backLinkTo) && <Back backLinkTo={backLinkTo} onBack={onBack} />}
                        {children}
                        {renderMenuOption && renderMenuOption()}
                    </Navbar.Header>
                </Navbar>
            </header>
        </>
    );
};

CustomProductHead.propTypes = componentPropTypes;
CustomProductHead.defaultProps = defaultPropTypes;

export default resizableRoute(CustomProductHead);
